<!-- 全局的预警提醒 -->
<template>
  <teleport :to="getContainer()">
    <div class="msg_wrap">
      <div class="allInfo" v-if="instantOrderList && instantOrderList.length > 1">
        <span class="title">即时工单</span>
        <a-radio-button value="large" class="closeall" @click.stop="closeAllInstant">
          关闭所有
        </a-radio-button>
      </div>
      <InstantItem
        v-for="(instant, insIndex) in instantOrderList"
        :key="instant.groupId"
        @instantClose="instantClose"
        :index="insIndex"
        :instantItem="instant"
      />
      <div class="allInfo" v-if="alarmInfo && alarmInfo.length > 1">
        <span class="title">预警提醒</span>
        <a-radio-button value="large" class="closeall" @click.stop="closeAll">
          关闭所有
        </a-radio-button>
      </div>
      <Item
        v-for="(item, index) in alarmInfo"
        :key="item.noonFlag"
        @close="close"
        :index="index"
        :base-data="item"
      />
    </div>
  </teleport>
</template>
<script setup>
import { defineProps, computed } from 'vue'
import { readWarningTip } from '@/api/AlarmReminder'
import store from '@/store'
import Item from './item.vue'
import InstantItem from './instantItem.vue'

const alarmInfo = computed(() => store.getters.alarmInfo)
defineProps({
  getContainer: {
    type: Function,
    default: () => document.body
  }
})

const closeAll = () => {
  alarmInfo.value = []
  store.commit('alarm/SET_ALARM_INFO', [])
}

const close = index => {
  const item = alarmInfo.value[index]
  const list = alarmInfo.value
  list.splice(index, 1)
  store.commit('alarm/SET_ALARM_INFO', list)
  readWarningTip({ noonFlag: item.noonFlag })
    .then(res => {
      console.log(res)
    })
    .catch(() => {
      //
    })
}

const instantOrderList = computed(() => store.getters.instantOrderList)

const instantClose = index => {
  const list = instantOrderList.value
  list.splice(index, 1)
  store.commit('instant/SET_INSTANT_LIST', list)
}
const closeAllInstant = () => {
  instantOrderList.value = []
  store.commit('instant/SET_INSTANT_LIST', [])
}
</script>
<style scoped lang="scss">
.allInfo {
  position: sticky;
  top: 0px;
  display: flex;
  //margin-top: 50px;
  justify-content: space-between;
  width: 100%;
  background: #e8f3ff;
  padding: 10px;
  align-items: center;
  z-index: 10;
  border: 1px solid #e8e8e8;
  box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.08), 0 5px 6px 0px rgba(0, 0, 0, 0.12),
    0 29px 18px -3px rgba(0, 0, 0, 0.05);
  margin-bottom: 6px;

  .title {
    font-weight: 500;
  }

  .closeall {
    border: 1px solid #1890ff;
    color: #1890ff;
    margin-left: 10px;
  }
  .closeall::before {
    background-color: #1890ff;
  }
}
.msg_wrap {
  position: fixed;
  right: 0px;
  //bottom: 34px;
  z-index: 100;
  max-height: calc(100vh - 48px);
  overflow: auto;
  top: 48px;
  padding-left: 5px;
}
</style>
